// One module of the dashboard grid. Every card on every role dashboard is one
// of these, so spacing, border and shadow are decided in a single place and the
// grid can mix spans without the cards drifting apart.
const Panel = ({
  title,
  subtitle,
  action,
  children,
  className = "",
  bodyClass,
}) => {
  const hasHeader = Boolean(title || action);
  const body = bodyClass ?? (hasHeader ? "px-5 pb-5 pt-4" : "p-5");

  return (
    <section
      className={`flex flex-col rounded-2xl border border-gray-200/80 bg-white shadow-card ${className}`}
    >
      {hasHeader && (
        <header className="flex items-start justify-between gap-3 px-5 pt-5">
          <div className="min-w-0">
            {title && (
              <h2 className="text-sm font-semibold tracking-tight text-gray-900">
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="mt-0.5 text-xs text-gray-500">{subtitle}</p>
            )}
          </div>
          {action && <div className="shrink-0">{action}</div>}
        </header>
      )}

      <div className={`flex-1 ${body}`}>{children}</div>
    </section>
  );
};

export default Panel;
